
import { useState, useMemo, useCallback } from 'react';
export const useCandidateFilters = (initialCandidates = [], initialFilters = {}) => {
  const [filters, setFilters] = useState({
    statuses: initialFilters.statuses || ['pending', 'approved', 'declined'],
    skillScore: initialFilters.skillScore || 0,
    behaviorScore: initialFilters.behaviorScore || 0,
    sortOrder: initialFilters.sortOrder || 'asc',
  });

  
  const setFilter = useCallback((filterName, value) => {
    setFilters(prevFilters => ({ ...prevFilters, [filterName]: value }));
  }, []);

  const toggleStatus = useCallback((status) => {
    setFilters(prevFilters => {
      const newStatuses = prevFilters.statuses.includes(status)
        ? prevFilters.statuses.filter((s) => s !== status)
        : [...prevFilters.statuses, status];
      return { ...prevFilters, statuses: newStatuses };
    });
  }, []);
  
  const resetFilters = useCallback(() => {
    setFilters({
      statuses: initialFilters.statuses || ['pending', 'approved', 'declined'],
      skillScore: initialFilters.skillScore || 0,
      behaviorScore: initialFilters.behaviorScore || 0,
      sortOrder: initialFilters.sortOrder || 'asc',
    });
  }, [initialFilters]);

  const filteredCandidates = useMemo(() => {
    let processed = [...initialCandidates];
    
    if (filters.statuses && filters.statuses.length > 0) {
        processed = processed.filter(pc => filters.statuses.includes(pc.status));
    }
    
    processed = processed.filter(pc => 
        ((pc.scorecardResults?.find(sc => sc.scorecardName === "skills")?.score ?? 0) * 100) >= filters.skillScore
    );
    
    processed = processed.filter(pc => 
        ((pc.scorecardResults?.find(sc => sc.scorecardName === "behaviors")?.score ?? 0) * 100) >= filters.behaviorScore
    );
    
    processed.sort((a, b) => {
        const dateA = a.createdAt || 0;
        const dateB = b.createdAt || 0;
        return filters.sortOrder === 'asc' ? dateA - dateB : dateB - dateA;
    });

    return processed;
  }, [initialCandidates, filters]);

  return {
    filters,
    setFilter,
    toggleStatus,
    resetFilters,
    filteredCandidates,
  };
};